import { blocksFontCSS } from "@pathwright/blocks/src/ui/typography"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import styled, { css } from "styled-components"
import { INCORRECT } from "./utils"

export const SCORING_RED = "#F58870"
export const SCORING_GREEN = "#00B48A"

export const QuestionContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0px auto;
  position: relative;

  ${(p) =>
    p.blockStyles
      ? `
    .TextArea__input textarea,
    .ParagraphQuestionView__rich-text-editor {
      border-color: ${p.blockStyles.styleAttributes.color} !important;
      color: ${p.blockStyles.styleAttributes.color} !important;
    }

    footer {
      .Button.primary[disabled],
      a.Button.primary[disabled],
      button.Button.primary[disabled],
      div {
        color: ${p.blockStyles.styleAttributes.color} !important;
      }
    }
  `
      : ""}
`

// TODO: eventually apply a more game-like card feel to each option.
export const QuestionOptionCardStyles = ({
  isChecked,
  checkedColor = "#999"
} = {}) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #ddd;

  .Checkbox,
  .RadioButton {
    background-color: transparent;
    padding: 0;
    width: 100%;
  }

  .Checkbox input:not(.ql-tooltip-editor input),
  .RadioButton input:not(.ql-tooltip-editor input) {
    box-shadow: 0 0 0 1px #999;
    border: 2px solid transparent;
    background-color: whitesmoke;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .RadioButton input:not(.ql-tooltip-editor input) {
    align-self: unset !important;
    height: 13px;
    width: 13px;
    border-radius: 50%;
  }

  .Checkbox input:not(.ql-tooltip-editor input) {
    margin-right: 2px;
    margin-top: -3px;
    height: 13px;
    width: 13px !important;
    border-radius: 2px;
  }

  ${isChecked &&
  `
    .Checkbox input:not(.ql-tooltip-editor input),
    .RadioButton input:not(.ql-tooltip-editor input) {
      box-shadow: 0 0 0 1px ${checkedColor};
      border-color: white;
      background-color: ${checkedColor};
    }
  `}

  ${blocksFontCSS()}
`

const FeedbackIndicatorContainer = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -1.7rem;
  top: calc(50% - 12px);

  .Pathicon {
    height: 100%;
    width: 100%;
  }
`

export const FeedbackIndicator = ({ optionFeedback }) => (
  <FeedbackIndicatorContainer>
    <Pathicon
      icon={optionFeedback === INCORRECT ? "x" : "check"}
      style={{
        color: optionFeedback === INCORRECT ? SCORING_RED : SCORING_GREEN
      }}
    />
  </FeedbackIndicatorContainer>
)
